const RECEIVE_POSTS = 'RECEIVE_POSTS';
export { RECEIVE_POSTS }
export const GET_ALL_LOGIN_DETAILS = 'GET_ALL_LOGIN_DETAILS';
